"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1({ isMasonryMobile, maxWidth768, children, }) {
    const wrapperCss = {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
    };
    const masonryWrapperCss = {
        width: maxWidth768 ? '50%' : '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
        padding: maxWidth768 ? '10px 4px' : '10px 5px',
        transition: 'left 0.3s ease, top 0.3s ease',
        '@keyframes comeIn': {
            '0%': { opacity: 0 },
            '100%': { opacity: 1 },
        },
        animation: 'comeIn ease 0.5s',
        animationIterationCount: 1,
    };
    const cardWrapperCss = isMasonryMobile ? masonryWrapperCss : wrapperCss;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "no_select", css: cardWrapperCss }, { children: children })));
}
exports.default = default_1;
